<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                contract_id: '',
                date: '',
                type_increase_id: '',
                value: '',
                deposit: '',
            },
            increases: [],
            send: false,
            load: false,
        }
    },
    methods: {
        isPast(date) {
            const today = new Date().toISOString().split('T')[0]; // yyyy-mm-dd
            return date < today;
        },
        clearForm() {
            this.form.id = '';
            this.form.date = '';
            this.form.type_increase_id = '';
            this.form.value = '';
            this.form.deposit = '';
        },
        closedModal() {
            this.clearForm();
            this.increases = [];
            this.send = false;
            this.load = false;
            this.$modal.hide('addNewIncreases');
        },
        async saveIncrease() {
            this.send = true;
            const data_form = new FormData();
            data_form.append('id', this.form.id)
            data_form.append('contract_id', this.form.contract_id)
            data_form.append('date', this.form.date)
            data_form.append('type_increase_id', this.form.type_increase_id)
            data_form.append('value', this.form.value)
            data_form.append('deposit', this.form.deposit)

            let _endpoint = '/increase_rent_bis';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/increase_rent_bis/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.clearForm();
                    this.list();
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }

        },
        async list() {
            this.load = true;
            let _endpoint = '/increase_rent_bis?contract_id=' + this.form.contract_id;
            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    this.increases = data;
                    this.load = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        async saveGroupIncrement() {
            let tit = 'Guardar aumentos';
            let txt = 'Seguro que quiere guardar los aumentos';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.send = true;
                    const data_form = new FormData();
                    data_form.append('increases', JSON.stringify(this.increases));


                    let _endpoint = '/increase_rent_bis';
                    data_form.append('_method', 'PUT');
                    _endpoint = `/increase_rent_bis/${this.form.contract_id}`;

                    try {
                        let { data } = await request.post(_endpoint, data_form)
                        if (data) {
                            this.successNotification(data.message);
                            this.list();
                            this.send = false;
                        }
                    } catch (error) {
                        this.errors = {};
                        this.send = false;
                        if (error.response) {
                            this.errors = await this.errorNotification(error);
                        }
                    }

                }
            });
        },
        async deleteIncrease(id) {

            let tit = 'Eliminar aumento';
            let txt = 'Seguro que quiere eliminar el aumento';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.send = true;
                    let _endpoint = `/increase_rent_bis/${id}`;
                    try {
                        let { data } = await request.destroy(_endpoint)
                        if (data) {
                            this.successNotification(data.message);
                            this.list();
                        }
                    } catch (error) {
                        this.errors = {};
                        if (error.response) {
                            this.errors = await this.errorNotification(error);
                        }
                    }
                }
            });
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    async mounted() {
        await this.catalogue.get_type_increase();
    },
    created() {
        Event.$on("event-show-addNewIncreasess", async (contract) => {

            console.log('contract')
            console.log(contract);
            this.form.contract_id = contract.id;
            this.list();
            this.$modal.show('addNewIncreases');
        })
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    watch: {
    },
}
</script>
<template>
    <modal name="addNewIncreases" :width="'80%'" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
            <i class="fa-solid fa-xmark"></i>
        </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Aumento de Renta</h5>
        </div>
        <div class="modal-body">
            <div class="row justify-content-center">
                <div class="col-md-4 mt-1" v-can="'add_rent_increase'">
                    <div class="row justify-content-center form-increases">
                        <div class="col-md-12">
                            <label>Fecha:</label>
                            <date-picker :disabled="!prop_edit" valueType="format" v-model="form.date"></date-picker>
                            <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                        </div>
                        <div class="col-md-12">
                            <label>Tipo:</label>
                            <select type="text" :disabled="!prop_edit" class="form-control"
                                v-model="form.type_increase_id">
                                <option value="">Sin tipo de aumento</option>
                                <option v-for="(type_payment, index_type_payment) in catalogue.type_increase"
                                    :value="type_payment.id" :key="index_type_payment">
                                    {{ type_payment.name }}
                                </option>
                            </select>
                            <div v-if="errors && errors.type_increase_id" class="text-danger">{{
                                errors.type_increase_id[0] }}</div>
                        </div>
                        <div class="col-md-12">
                            <label
                                v-if="form.type_increase_id == '' || form.type_increase_id == 2 || form.type_increase_id == 3">Porcentaje:</label>
                            <label v-if="form.type_increase_id == 1 || form.type_increase_id == 4">Monto:</label>
                            <input class="form-control" :disabled="!prop_edit" v-model="form.value" type="number"
                                step="any">
                            <div v-if="errors && errors.value" class="text-danger">{{ errors.value[0] }}</div>
                        </div>
                        <!-- <div class="col-md-12" v-if="form.type_increase_id == 1">
                            <label>Deposito de garantía</label>
                            <money :disabled="!prop_edit" class="form-control" required v-model="form.deposit">
                            </money>
                            <div v-if="errors && errors.deposit" class="text-danger">{{ errors.deposit[0] }}</div>
                        </div> -->
                        <div class="col-md-12 mt-2 text-right">
                            <button type="button" class="btn btn-outline-success btn-sm" @click="saveIncrease()">
                                <i class="fa-solid fa-plus"></i> Agregar aumento
                            </button>
                        </div>
                    </div>
                </div>

                <div class="mt-1 col-md-8 h-100">
                    <div class="row">
                        <div class="col-md-12 table-responsive">
                            <table class="table mb-4">
                                <thead>
                                    <tr>
                                        <th class="px-2 py-1 border">Fecha</th>
                                        <th class="px-2 py-1 border">Tipo</th>
                                        <th class="px-2 py-1 border">&nbsp;</th>
                                        <!-- <th class="px-2 py-1 border">Deposito</th> -->
                                        <th class="px-2 py-1 border">Publicar</th>
                                        <th class="px-2 py-1 border">Acción</th>
                                    </tr>
                                </thead>
                                <tbody v-if="load">
                                    <td class="text-center" colspan="4">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </td>
                                </tbody>
                                <tbody v-else-if="increases.length > 0">
                                    <tr v-for="(item, index) in increases" :key="index" class="border-t">
                                        <td>
                                            {{ item.date | toDateTime }}
                                        </td>
                                        <td>
                                            <span v-if="!item.type_increase">Sin tipo de aumento</span>
                                            <span v-else>{{ item.type_increase.name }}</span>
                                        </td>
                                        <td>
                                            <money :disabled="item.published == 1 || !prop_edit"
                                                v-if="item.type_increase_id == 1" class="form-control form-control-sm"
                                                v-model="item.value"></money>
                                            <input :disabled="item.published == 1 || !prop_edit" v-else type="number"
                                                class="form-control form-control-sm" v-model="item.value">
                                        </td>
                                        <!-- <td>
                                            <money :disabled="item.published == 1 || !prop_edit"
                                                v-if="item.type_increase_id == 1" class="form-control form-control-sm"
                                                v-model="item.deposit"></money>
                                        </td> -->
                                        <td>
                                            <input :disabled="item.published == 1 || !prop_edit" type="checkbox"
                                                v-if="item.published == 0" class="form-control form-control-sm"
                                                value="1" v-model="item.publicPreview">
                                            <span v-else class="badge badge-success">Publicado</span>

                                        </td>
                                        <td>
                                            <button type="button" v-can="'delete_rent_increase'"
                                                class="btn btn-outline-danger btn-sm" v-if="item.published != 1"
                                                @click="deleteIncrease(item.id)">
                                                <i class="fa-solid fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr class="text-center">
                                        <td colspan="4">
                                            Sin resultados
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <div class="col-md-12">
                    <hr>
                    <button type="button" :disabled="send || !prop_edit" v-can="'edit_rent_increase'"
                        @click="saveGroupIncrement()" class="btn float-right btn-outline-success">
                        <span v-if="send">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                        </span>
                        <span v-else>
                            <i class="fas fa-save"></i> Guardar
                        </span>
                    </button>

                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>

                </div>

            </div>
        </div>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.form-increases {
    background: #e9e9e9;
    padding: 15px;
}

.divCard {

    padding: 10px;
    border: 1px solid #eee;
    border-radius: 10px;
}
</style>